import { ModalData, useModal } from '../state/ModalProvider';

import { HeaderCallToAction } from './styles';

interface ModalTriggerProps {
  data: ModalData;
  onClick?: () => void;
}

const ModalTrigger = ({ data, onClick }: ModalTriggerProps) => {
  const { openModal } = useModal();
  const { modalCTA, modalType } = data;
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    openModal(modalType);
  };
  return (
    <HeaderCallToAction
      variant={modalCTA?.buttonType}
      onClick={handleClick}
    >
      {modalCTA?.buttonLabel}
    </HeaderCallToAction>
  );
};

export default ModalTrigger;
